import { ReferralSystemSchema } from './ReferralSystem'
import { ReferralCodeSchema } from './ReferralCode'
import { parseReflink, Reflink } from './Reflink'
import { ensure } from '../../util/src/ensure'
import { allReferralSystems } from '../../Wikifacts/data/allReferralSystems'
import { z } from 'zod'

export const PackedReflinkSchema = z.tuple([ReferralSystemSchema.shape.id, ReferralCodeSchema])

export const PackedReflinksSchema = z.array(PackedReflinkSchema)

export type PackedReflink = z.infer<typeof PackedReflinkSchema>

export function fromReflinksToPackedReflinks(reflinks: Reflink[]): PackedReflink[] {
  return reflinks.map(r => ([r.system.id, r.code]))
}

export function fromPackedReflinksToReflinks(packedReflinks: PackedReflink[]): Reflink[] {
  return packedReflinks.map(r => parseReflink({
    system: ensure(allReferralSystems.find(s => s.id === r[0])),
    code: r[1],
  }))
}
